import { Icons } from 'react-toastify';

const TOAST_ICONS = {
  success: Icons.success({ theme: 'light', type: 'success' }),
  info: Icons.info({ theme: 'light', type: 'info' }),
  warning: Icons.warning({ theme: 'light', type: 'warning' }),
  error: Icons.error({ theme: 'light', type: 'error' }),
  loading: Icons.spinner()
};

export default TOAST_ICONS;
